import { timestamp } from 'drizzle-orm/pg-core';
export const timestamps = () => ({
    createdAt: timestamp('created_at').defaultNow().notNull(),
    updatedAt: timestamp('updated_at')
        .defaultNow()
        .$onUpdate(() => new Date())
        .notNull(),
    deletedAt: timestamp('deleted_at'),
});
//# sourceMappingURL=index.js.map